import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../utils/api';
import { Module, Menu } from '../dtos/module';
import { accessToken } from '../utils/helper';

interface ModuleState {
  moduleList: { data: Module[] } | { data: [] };
  menuList: { data: Menu[] } | { data: [] };
  loading: boolean;
  error: string | null;
}

const initialState: ModuleState = {
  moduleList: { data: [] },
  menuList: { data: [] },
  loading: false,
  error: null,
};

export const getAllModuleTrigger = createAsyncThunk('get/module', async () => {
  try {
    const response = await api.get<{ data: Module[] }>('/modules', accessToken());
    return response.data;
  } catch (error) {
    console.log(error);
    return { data: [] };
  }
});

export const getMenusByModuleTrigger = createAsyncThunk(
  'menus/:id',
  async (module: number | undefined) => {
    try {
      const response = await api.get<{ data: Menu[] }>(
        `/menus/1?module=${module ? module : ''}`,
        accessToken(),
      );
      return response.data;
    } catch (error) {
      console.log(error);
      return { data: [] };
    }
  },
);

// Create slice
const moduleSlice = createSlice({
  name: 'module',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllModuleTrigger.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllModuleTrigger.fulfilled, (state, action) => {
        state.loading = false;
        state.moduleList = action.payload as { data: Module[] };
      })
      .addCase(getAllModuleTrigger.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to load posts';
      })
      .addCase(getMenusByModuleTrigger.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMenusByModuleTrigger.fulfilled, (state, action) => {
        state.loading = false;
        state.menuList = action.payload;
      })
      .addCase(getMenusByModuleTrigger.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to load posts';
      });
  },
});

// Export the reducer to be added to the store
export default moduleSlice.reducer;
